<!-- 
  안드로이드 http://192.168.1.230:7777/checkout/complete?imp_uid=imp_365950464694&merchant_uid=502636&imp_success=true
  아이폰 http://192.168.1.230:7777/checkout/complete?imp_uid=imp_168499063246&merchant_uid=502638&imp_success=true

  
  아이폰 http://192.168.0.4:7777/checkout/complete?imp_uid=imp_168499063246&merchant_uid=502638&imp_success=true
-->
<template>
  <section>
    <div class="payment__done">
      <div class="info">
        <p>{{msg}}</p>
        <div class="link_box">
            <button @click="back">확인</button>
        </div>
      </div>
      
    </div>
    

    <loading v-show="loading"/>
  </section>
</template>

<script>
import client from '../client/client'
import Loading from '../components/Loading'
import { useRoute } from 'vue-router'
export default {
  name:'CheckoutComplete',
  components: {
    Loading,
  },
  data() {
    const route = useRoute()
    const { query } = route
    const { type } = query;
    return {
      type,
      loading:true,
      success: this.getSuccess(query),
      impUid: query.imp_uid,
      merchantUid: query.merchant_uid,
      errorMessage: `[${query.error_code}] ${query.error_msg}`,
    };
  },
  methods: {
    async update() {
      const route = useRoute()
      const { query } = route
      client.updateToken(query)
      if(this.success) {
        let result = await client.post('/api/order/complete', {
          impUid: this.impUid,
          merchantUid : this.merchantUid
        })

        this.loading = false
        if(result && result.r) {
          this.msg = '주문이 완료되었습니다'
        } else {
          this.msg = '주문이 실패하였습니다'
        }
        
      } else {
        this.loading = false
        this.msg = '주문이 실패하였습니다'
      }
    },
    back(event){
      window.location.href = 'jevil://devil.com/rootScreen/my?subtab=3'
    },
    getSuccess(query) {
      const { success } = query;
      const impSuccess = query.imp_success;
      if (impSuccess === undefined) {
        if (typeof success === 'string') {
          return success === 'true';
        }
        return success;
      }
      if (typeof impSuccess === 'string') {
        return impSuccess === 'true';
      }
      return impSuccess;
    },
    handleGoBack() {
      const route = useRoute()
      route.push(`/${this.type}`);
    },
  },
  async mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
  .payment__done{
    display:flex;
    width:100%;
    margin:0 auto;
    min-height:100vh;
    align-items:center;
    justify-content:center;
    background:#F4F4F4;
    .info{
      p{
        font-size:16px;
        color:#343434;
        margin:0;
        padding:0 0 20px;
        text-align:center;
      }
      button{
        width:130px;
        line-height:52px;
        text-align:center;
        border-radius:8px;
        font-size:16px;
        font-weight:bold;
        &:first-child{
          border:1px solid #F2632A;
          background:#fff;
          color:#F2632A;
          margin-right:8px;
        }
        &:last-child{
          border:1px solid #F2632A;
          background:#F2632A;
          color:#fff;
          margin-left:8px;
        }
      }
    }
  }
</style>
